import { queryOptions, useQuery } from '@tanstack/react-query';

import { productsApi } from '../api/products-api';

import { productKeys } from './product-keys';

export function productQueryOptions(productId: string) {
  return queryOptions({
    queryKey: productKeys.detail(productId),
    queryFn: () => productsApi.get(productId),
  });
}

export function useProduct(productId: string) {
  return useQuery(productQueryOptions(productId));
}
